import { FormValidations } from "features/shared/forms/hooks/useForm";

export const generalRequirementFormValidations = (): FormValidations => {
  return {
    description: {
      required: true,
      type: "OnlyRequired"
    } 
  };
}